import React from 'react';
import { pxToRem } from '../util';
import { ConfigProvider, Line } from '@ant-design/charts';
import CardHeader from './CardHeader';
const Box1 = (props: { charts: any }) => {
  const color = 'rgb(206, 234, 255)';
  const [data, setData] = React.useState([]);
  React.useEffect(() => {
    // 模拟数据加载
    setData(props.charts?.somatosensoryImprovementTrend || []);
    const list = [];
    (props.charts?.somatosensoryImprovementTrend || []).forEach((item: any) => {
      (item.list || []).forEach((subItem: any) => {
        list.push({
          date: item.date,
          series: subItem.name,
          value: subItem.improvementRate,
        });
      });
    });
    setData(list);
  }, [props.charts]);
  const config = {
    interaction: {
      brushFilter: true,
    },
    colorField: 'series',
    yField: 'value',
    xField: (d) => new Date(d['date']),
    axis: {
      x: {
        labelAutoRotate: false,
      },
    },
    data: data,
    legend: {
      color: {
        title: false,
        position: 'bottom',
        rowPadding: 5,
      },
    },
  };
  return (
    <div
      style={{
        background:
          'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        height: '35vh',
        padding: '5px',
        boxSizing: 'border-box',
        fontFamily: '阿里妈妈数黑体 Bold',
      }}
    >
      {/* <div
        style={{
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          fontSize: pxToRem(18),
        }}
      >
        <span>健康管理下近3年体感改善趋势</span>
        <span
          style={{
            fontSize: pxToRem(12),
            display: 'inline-block',
            padding: '1px 4px',
            color,
            width: 'fit-content',
            borderRadius: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          }}
        >
          The trend of improved physical sensations in the past 3 years
        </span>
      </div> */}
      <CardHeader
        title="健康管理下近3年体感改善趋势"
        subtitle="The trend of improved physical sensations"
      />

      <div>
        <div style={{ height: '28vh', marginTop: pxToRem(10) }}>
          <ConfigProvider
            common={{
              theme: {
                type: 'dark', // 基于 dark 主题定制
                axis: {
                  labelFill: color,
                },
              },
            }}
          >
            <Line {...config} />
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};
export default Box1;
